import { render, staticRenderFns } from "./EchartRadar.vue?vue&type=template&id=6ddc137a&"
import script from "./EchartRadar.vue?vue&type=script&lang=js&"
export * from "./EchartRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports